// extracted by mini-css-extract-plugin
export default {"modal-template-policy-number":"styles_modal-template-policy-number__TCZmy"};